
define('ldsh!modules/form_editor/templates/preview_custom_date_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(labelVisible) { ;
__p += '\n<label class="control-label col-sm-3" for="">' +
((__t = ( labelText )) == null ? '' : __t) +
'</label>\n';
 } ;
__p += '\n<div class="col-sm-9 js-control">\n    <amp-date-picker\n        id="' +
((__t = ( AMPComponentId )) == null ? '' : __t) +
'"\n        type="single"\n        mode="overlay"\n        layout="container"\n        on="select:AMP.setState({' +
((__t = ( inputFieldId )) == null ? '' : __t) +
': event.date})"\n        format="' +
((__t = ( format )) == null ? '' : __t) +
'"\n        input-selector="[id=' +
((__t = ( inputFieldId )) == null ? '' : __t) +
']"\n        class="example-picker space-between"\n        date="{{ageLimit:' +
((__t = ( ageLimit )) == null ? '' : __t) +
';format:' +
((__t = ( format )) == null ? '' : __t) +
'}}"\n        max="{{ageLimit:' +
((__t = ( ageLimit )) == null ? '' : __t) +
';format:' +
((__t = ( format )) == null ? '' : __t) +
'}}"\n        min="' +
((__t = ( min )) == null ? '' : __t) +
'"\n        age-limit="' +
((__t = ( ageLimit )) == null ? '' : __t) +
'">\n    <input\n        class="form-control form-control-date"\n        id="' +
((__t = ( inputFieldId )) == null ? '' : __t) +
'"\n        name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n        data-i18n="[placeholder]landingPage.datepicker.select"\n        ' +
((__t = ( isRequired ? 'required' : '' )) == null ? '' : __t) +
'\n    />\n\n    <button\n        on="tap: ' +
((__t = ( AMPComponentId )) == null ? '' : __t) +
'.clear"\n        type="button"\n        data-i18n="datepicker.clear">\n    </button>\n</amp-date-picker>\n</div>\n';

}
return __p
};});

